var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-page-popup-form" },
    [
      _c(
        "el-card",
        { staticClass: "setting-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("i", { staticClass: "el-icon-setting" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.isEdit
                      ? _vm.popupType === 1
                        ? "编辑菜单页弹窗"
                        : "编辑点餐首页弹窗"
                      : _vm.popupType === 1
                      ? "添加菜单页弹窗"
                      : "添加点餐首页弹窗"
                  )
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "card-content" }, [
            _c("div", { staticClass: "setting-content" }, [
              _c(
                "div",
                { staticClass: "left-panel" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "menuPageForm",
                      staticClass: "popup-form beautify-form",
                      attrs: {
                        model: _vm.formData,
                        rules: _vm.rules,
                        "label-width": "120px",
                        size: "small",
                      },
                    },
                    [
                      _c("div", { staticClass: "form-layout" }, [
                        _c(
                          "div",
                          { staticClass: "form-left" },
                          [
                            _c("div", { staticClass: "section-title" }, [
                              _vm._v("基础信息"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "标题", prop: "title" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    placeholder: "请输入标题内容",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.formData.title,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "title", $$v)
                                    },
                                    expression: "formData.title",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "推荐类型",
                                  prop: "recommendType",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    on: { change: _vm.changeRecommendInfo },
                                    model: {
                                      value: _vm.formData.recommendType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "recommendType",
                                          $$v
                                        )
                                      },
                                      expression: "formData.recommendType",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: 1 } }, [
                                      _vm._v("NOTHING"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 2 } }, [
                                      _vm._v("领券弹窗"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 3 } }, [
                                      _vm._v("系统弹窗"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 5 } }, [
                                      _vm._v("调查问卷"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 6 } }, [
                                      _vm._v("外部小程序"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 7 } }, [
                                      _vm._v("微信红包封面"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "推荐内容" } },
                              [
                                _vm.formData.recommendType != 1
                                  ? _c(
                                      "div",
                                      { staticClass: "inline-items" },
                                      [
                                        _vm.formData.recommendType == 6
                                          ? _c(
                                              "el-select",
                                              {
                                                staticClass: "inline-select",
                                                attrs: {
                                                  placeholder:
                                                    "请选择小程序类型",
                                                  clearable: "",
                                                },
                                                on: {
                                                  change:
                                                    _vm.changeRecommendContentSub,
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .recommendContentSub,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "recommendContentSub",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.recommendContentSub",
                                                },
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: "社区",
                                                    value: "GAGAS",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-option", {
                                                  attrs: {
                                                    label: "其他",
                                                    value: "other",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        (_vm.formData.recommendContentSub ==
                                          "GAGAS" &&
                                          this.formData.recommendType == 6) ||
                                        _vm.formData.recommendType == 3 ||
                                        _vm.formData.recommendType == 4 ||
                                        _vm.formData.recommendType == 8
                                          ? _c(
                                              "el-select",
                                              {
                                                staticClass: "inline-select",
                                                attrs: {
                                                  filterable: "",
                                                  placeholder: "请选择页面",
                                                  clearable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .recommendContentId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "recommendContentId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.recommendContentId",
                                                },
                                              },
                                              _vm._l(
                                                _vm.pageList,
                                                function (opt) {
                                                  return _c("el-option", {
                                                    key: opt.id,
                                                    attrs: {
                                                      label: opt.label,
                                                      value: opt.id,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.formData.recommendType == 2 ||
                                        (_vm.formData.recommendType == 6 &&
                                          _vm.formData.recommendContentSub ==
                                            "other")
                                          ? _c("el-input", {
                                              staticClass: "inline-input",
                                              attrs: {
                                                placeholder: "请输入",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.formData.recommendContent,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "recommendContent",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.recommendContent",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.formData.recommendType == 5 ||
                                        _vm.formData.recommendType == 7 ||
                                        (_vm.formData.recommendType == 6 &&
                                          _vm.formData.recommendContentSub ==
                                            "other")
                                          ? _c("el-input", {
                                              staticClass: "inline-input",
                                              attrs: {
                                                placeholder: "请输入URL",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.formData
                                                    .recommendContentId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "recommendContentId",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.recommendContentId",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.formData.recommendType == 3 ||
                                        _vm.formData.recommendType == 5 ||
                                        _vm.formData.recommendType == 6 ||
                                        _vm.formData.recommendType == 8
                                          ? _c("el-input", {
                                              staticClass: "inline-input",
                                              attrs: {
                                                placeholder:
                                                  "请输入参数，如：id=122&name=test",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.formData
                                                    .recommendContentParam,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "recommendContentParam",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.recommendContentParam",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "recommend-type-hint",
                                          },
                                          [
                                            _vm.formData.recommendType == 2
                                              ? _c(
                                                  "span",
                                                  { staticClass: "hint-text" },
                                                  [
                                                    _vm._v(
                                                      "请填写优惠券发放活动ID（活动类型需为领取，只填写id）"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.formData.recommendType == 3 ||
                                            _vm.formData.recommendType == 4 ||
                                            _vm.formData.recommendType == 8
                                              ? _c(
                                                  "span",
                                                  { staticClass: "hint-text" },
                                                  [
                                                    _vm._v(
                                                      "请选择跳转页面及输入参数，参数格式如：id=122&name=test"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.formData.recommendType == 5
                                              ? _c(
                                                  "span",
                                                  { staticClass: "hint-text" },
                                                  [
                                                    _vm._v(
                                                      "请选择问卷地址及输入参数，参数格式如：id=122&name=test"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.formData.recommendType == 6
                                              ? _c(
                                                  "span",
                                                  { staticClass: "hint-text" },
                                                  [
                                                    _vm._v(
                                                      "请填写外部小程序appid、跳转地址及参数，参数格式如：id=122&name=test"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.formData.recommendType == 7
                                              ? _c(
                                                  "span",
                                                  { staticClass: "hint-text" },
                                                  [
                                                    _vm._v(
                                                      "请填写微信红包封面地址URL"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "推荐优先级",
                                  prop: "recommendPriority",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "priority-container" },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        min: 1,
                                        max: 999,
                                        placeholder: "请输入优先级",
                                      },
                                      model: {
                                        value: _vm.formData.recommendPriority,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "recommendPriority",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.recommendPriority",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: "优先展示优先级高的",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-question priority-help-icon",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "发送场景", prop: "sendScene" },
                              },
                              [
                                _c(
                                  "el-checkbox-group",
                                  {
                                    model: {
                                      value: _vm.formData.sendScene,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "sendScene", $$v)
                                      },
                                      expression: "formData.sendScene",
                                    },
                                  },
                                  [
                                    _c("el-checkbox", { attrs: { label: 3 } }, [
                                      _vm._v("外卖"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-checkbox", { attrs: { label: 1 } }, [
                                      _vm._v("堂食"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-checkbox", { attrs: { label: 2 } }, [
                                      _vm._v("自提"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "section-title" }, [
                              _vm._v("人群与条件"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "是否会员", prop: "isVip" } },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.formData.isVip,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "isVip", $$v)
                                      },
                                      expression: "formData.isVip",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: 1 } }, [
                                      _vm._v("全部"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 2 } }, [
                                      _vm._v("是"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 3 } }, [
                                      _vm._v("否"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.formData.isVip == 2
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "会员级别",
                                      prop: "vipGrade",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-checkbox-group",
                                      {
                                        model: {
                                          value: _vm.formData.vipGrade,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "vipGrade",
                                              $$v
                                            )
                                          },
                                          expression: "formData.vipGrade",
                                        },
                                      },
                                      _vm._l(_vm.vipGrades, function (grade) {
                                        return _c(
                                          "el-checkbox",
                                          {
                                            key: grade.id,
                                            attrs: { label: grade.id },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(grade.name) +
                                                "\n                    "
                                            ),
                                          ]
                                        )
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "新人券是否过期",
                                  prop: "isNewPeopleCoupon",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.formData.isNewPeopleCoupon,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "isNewPeopleCoupon",
                                          $$v
                                        )
                                      },
                                      expression: "formData.isNewPeopleCoupon",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: 1 } }, [
                                      _vm._v("全部"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 2 } }, [
                                      _vm._v("过期"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 3 } }, [
                                      _vm._v("未过期"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "添加企微", prop: "isAddQy" } },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.formData.isAddQy,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "isAddQy", $$v)
                                      },
                                      expression: "formData.isAddQy",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: 1 } }, [
                                      _vm._v("全部"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 2 } }, [
                                      _vm._v("是"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 3 } }, [
                                      _vm._v("否"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "是否下单",
                                  prop: "isSaleOrder",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.formData.isSaleOrder,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "isSaleOrder",
                                          $$v
                                        )
                                      },
                                      expression: "formData.isSaleOrder",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: 1 } }, [
                                      _vm._v("全部"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 2 } }, [
                                      _vm._v("下过单"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 3 } }, [
                                      _vm._v("未下过单"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "分组类型",
                                  prop: "cdpGrpType",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    on: { change: _vm.handleCdpGrpTypeChange },
                                    model: {
                                      value: _vm.formData.cdpGrpType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "cdpGrpType",
                                          $$v
                                        )
                                      },
                                      expression: "formData.cdpGrpType",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: 0 } }, [
                                      _vm._v("不匹配"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 1 } }, [
                                      _vm._v("CDP分组"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 2 } }, [
                                      _vm._v("消费行为"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.formData.cdpGrpType !== 0
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "分组选择",
                                      prop: "cdpGrpId",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "inline-select",
                                        attrs: {
                                          placeholder: "请选择分组",
                                          clearable: "",
                                          filterable: "",
                                          remote: "",
                                          "remote-method":
                                            _vm.queryCdpGroupList,
                                          loading: _vm.cdpGroupLoading,
                                        },
                                        model: {
                                          value: _vm.formData.cdpGrpId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "cdpGrpId",
                                              $$v
                                            )
                                          },
                                          expression: "formData.cdpGrpId",
                                        },
                                      },
                                      _vm._l(
                                        _vm.cdpGroupOptions,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "section-title" }, [
                              _vm._v("用户与素材"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "用户类型", prop: "userType" },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.formData.userType,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "userType", $$v)
                                      },
                                      expression: "formData.userType",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: 1 } }, [
                                      _vm._v("全部"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 2 } }, [
                                      _vm._v("新用户"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 3 } }, [
                                      _vm._v("老用户"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "展示图片", prop: "showImage" },
                              },
                              [
                                _c(
                                  "el-upload",
                                  {
                                    staticClass: "upload-picture-wall",
                                    attrs: {
                                      action: "",
                                      "list-type": "picture-card",
                                      "file-list": _vm.fileList,
                                      "on-change": _vm.handleImageChange,
                                      "on-remove": _vm.handleImageRemove,
                                      "before-upload": _vm.beforeImageUpload,
                                      limit: 1,
                                      "on-exceed": _vm.handleExceed,
                                      accept: "image/*",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "file",
                                        fn: function (ref) {
                                          var file = ref.file
                                          return _c("div", {}, [
                                            _c("img", {
                                              staticClass:
                                                "el-upload-list__item-thumbnail",
                                              attrs: {
                                                src: _vm.imagePrefix + file.url,
                                                alt: "",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-list__item-actions",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-upload-list__item-preview",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleImagePreview(
                                                          file
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-zoom-in",
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-upload-list__item-delete",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleImageRemove(
                                                          file
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-delete",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ])
                                        },
                                      },
                                    ]),
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-plus",
                                      attrs: { slot: "default" },
                                      slot: "default",
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-dialog",
                                  {
                                    attrs: {
                                      visible: _vm.previewVisible,
                                      size: "tiny",
                                    },
                                    on: {
                                      "update:visible": function ($event) {
                                        _vm.previewVisible = $event
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        width: "100%",
                                        src:
                                          _vm.imagePrefix + _vm.previewImageUrl,
                                        alt: "",
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "展示平台",
                                  prop: "showPlatform",
                                },
                              },
                              [
                                _c(
                                  "el-checkbox-group",
                                  {
                                    model: {
                                      value: _vm.formData.showPlatform,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "showPlatform",
                                          $$v
                                        )
                                      },
                                      expression: "formData.showPlatform",
                                    },
                                  },
                                  [
                                    _c("el-checkbox", { attrs: { label: 1 } }, [
                                      _vm._v("微信"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-checkbox", { attrs: { label: 2 } }, [
                                      _vm._v("支付宝"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "section-title" }, [
                              _vm._v("时间与渠道"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "弹窗展示时间",
                                  prop: "dateRange",
                                },
                              },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "datetimerange",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                    format: "yyyy-MM-dd HH:mm:ss",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                  },
                                  model: {
                                    value: _vm.formData.dateRange,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "dateRange", $$v)
                                    },
                                    expression: "formData.dateRange",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "section-title" }, [
                              _vm._v("展示设置"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "是否启用", prop: "isEnable" },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.formData.isEnable,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "isEnable", $$v)
                                      },
                                      expression: "formData.isEnable",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: true } }, [
                                      _vm._v("是"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "el-radio",
                                      { attrs: { label: false } },
                                      [_vm._v("否")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "是否展示", prop: "isShow" } },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.formData.isShow,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "isShow", $$v)
                                      },
                                      expression: "formData.isShow",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: true } }, [
                                      _vm._v("是"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "el-radio",
                                      { attrs: { label: false } },
                                      [_vm._v("否")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "备注", prop: "remark" } },
                              [
                                _c("div", { staticClass: "remark-box" }, [
                                  _vm._v(
                                    "\n                    如果是弹窗类显示，则用户第一次显示弹窗，会记录标识存在客户端，避免过于打扰用户，则7天之后该弹窗能在用户端不在显示。\n                    "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "* 领券：点击弹窗，领取优惠券。\n                    "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "* 系统：点击弹窗后跳转。\n                    "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "* 跳转：自动跳转至，仅一次/账号；\n                    "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "* 问卷：点击弹窗后，半屏页面形式打开问卷调查\n                  "
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "action-buttons beautify-btns" },
                        [
                          _c("el-button", { on: { click: _vm.handleCancel } }, [
                            _vm._v("\n                取消\n              "),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSubmit },
                            },
                            [_vm._v("\n                保存\n              ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right-panel" },
                [
                  _c(
                    "el-card",
                    { staticClass: "store-card", attrs: { shadow: "hover" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "card-header",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [
                            _c("i", { staticClass: "el-icon-office-building" }),
                            _vm._v(
                              "\n                选择门店\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "header-actions" },
                            [
                              _c(
                                "el-tooltip",
                                { attrs: { effect: "dark", placement: "top" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        "\n                    上传Excel文件批量选中门店"
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "\n                    格式：第一列填写门店ID（纯数字）"
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "\n                    支持 .xlsx / .xls 格式\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-upload",
                                    {
                                      ref: "excelUpload",
                                      staticStyle: { display: "inline-block" },
                                      attrs: {
                                        action: "",
                                        "auto-upload": false,
                                        "show-file-list": false,
                                        accept: ".xlsx,.xls",
                                        "on-change": _vm.handleExcelImport,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-upload2",
                                          }),
                                          _vm._v(
                                            "\n                      导入Excel\n                    "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: { click: _vm.selectAllStores },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-check" }),
                                  _vm._v(
                                    "\n                  全选\n                "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-content" }, [
                        _c(
                          "div",
                          { staticClass: "store-join-type" },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { size: "small" },
                                model: {
                                  value: _vm.formData.storeJoinType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "storeJoinType", $$v)
                                  },
                                  expression: "formData.storeJoinType",
                                },
                              },
                              [
                                _c("el-radio-button", { attrs: { label: 1 } }, [
                                  _vm._v("指定门店参与"),
                                ]),
                                _vm._v(" "),
                                _c("el-radio-button", { attrs: { label: 2 } }, [
                                  _vm._v("指定门店不参与"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "search-box" },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "搜索门店名称",
                                "prefix-icon": "el-icon-search",
                                clearable: "",
                              },
                              model: {
                                value: _vm.storeSearchText,
                                callback: function ($$v) {
                                  _vm.storeSearchText = $$v
                                },
                                expression: "storeSearchText",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "store-tree" },
                          [
                            _c("el-tree", {
                              ref: "storeTree",
                              attrs: {
                                data: _vm.storeTreeData,
                                props: _vm.defaultProps,
                                "default-expanded-keys": _vm.expandedKeys,
                                "default-checked-keys": _vm.checkedKeys,
                                "filter-node-method": _vm.filterNode,
                                "show-checkbox": "",
                                "node-key": "nodeKey",
                              },
                              on: { check: _vm.handleStoreCheck },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }